import { ChevronRight, CircleAlert, Loader2, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ProfileCardProps } from './types';

const ProfileCard = (props: ProfileCardProps) => {
  const {
    isLoading,
    onOpenProfileEdit,
    profile
  } = props;

  if (isLoading) {
    return (
      <section className="flex items-center gap-2 p-4 rounded-2xl border border-border-strong bg-surface">
        <div className="flex min-h-12 flex-1 items-center justify-center">
          <Loader2 className="size-5 animate-spin text-muted-foreground" />
        </div>
      </section>
    );
  }

  return (
    <button
      className={cn(
        'flex w-full items-center gap-2 p-4',
        'text-left',
        'rounded-2xl border border-border-strong bg-surface',
        'transition-colors hover:bg-accent-soft/60 active:bg-[hsl(var(--state-selected-bg))]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
      )}
      onClick={onOpenProfileEdit}
      type="button"
    >
      <div
        className={cn(
          'flex size-8 shrink-0 items-center justify-center',
          'rounded-[8px] bg-state-disabled-bg/[0.05]'
        )}
      >
        <User className="size-4 text-foreground" />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="truncate font-sans text-sm font-semibold leading-5 tracking-normal text-foreground">
          {profile.name || 'Имя не указано'}
        </h2>
        <p className="mt-1 truncate text-xs leading-4 text-muted-foreground">{profile.email}</p>
        {!profile.emailVerified ? (
          <p className="mt-1 flex min-w-0 items-center gap-2 text-xs leading-4 text-muted-foreground">
            <CircleAlert className="size-4 shrink-0 text-destructive" />
            <span className="truncate">Почта не подтверждена</span>
          </p>
        ) : null}
      </div>
      <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
    </button>
  );
};

export default ProfileCard;